const uuidv1 = require("uuid/v1")
import moment from "moment"

export default class CartItem {
	constructor(item, date, time, eventId) {
		this.eventId = eventId != undefined ? eventId : null
		this.quantity = item.quantity
		this.name = item.name
		this.img = item.img
		this.id = item.id
		this.options = item.options || {}
		this.price = item.price
		this.calcedPrice = item.calcedPrice ? item.calcedPrice : item.price
		this.comments = item.comments
		this.rest_id = item.restaurant_slug
		this.restaurant_id = item.restaurant_id
		this.menu_id = item.menu_id
		this.menu_type = item.menu_type
		this.uuid = item.uuid ? item.uuid : uuidv1()
		this.contains_alcohol = item.contains_alcohol
		this.delivery_slot = null
		this.labels = item.labels
		if (date) {
			this.delivery_date = date
			this.delivery_time = null
		}
		if (date && time) {
			this.delivery_time = time
			this.delivery_slot = moment(`${date} ${time}`)
				.utc()
				.format("YYYY-MM-DD HH:mm:ss")
		}
	}

	static convertToChargeCardModel(cartItem) {
		let metas = []
		if (cartItem.options) {
			for (let optionKey in cartItem.options) {
				if (cartItem.options[optionKey] && cartItem.options[optionKey].length > 0){
					const options = cartItem.options[optionKey]
					metas.push({
						id: options[0].meta_id,
						name: optionKey,
						values: options.map((option) => {
							return {
								id: option.id,
								name: option.name,
								price: option.price
							}
						})
					})
				}
			}
		}

		return {
			id: cartItem.id,
			quantity: cartItem.quantity,
			menu_id: cartItem.menu_id,
			event_id: cartItem.eventId,
			delivery_slot: cartItem.delivery_slot,
			metas: metas,
			comments: cartItem.comments
		}
	}
}